import {useMemo} from 'react'
import {useReviews} from './use-reviews'

export function useApprovedReviews() {
  const reviewSummaries = useReviews()

  return useMemo(() => reviewSummaries.filter(reviewSummary => reviewSummary.state === 'APPROVED'), [reviewSummaries])
}
